module.exports = __webpack_public_path__ + "static/media/kirigaya-suguha.d2384010.png";